<div class="row card-layout js-orderSummary card-layout--order-summary offset-top text-dark">

  <div class="row row--border-bottom pb1">
    <div class="col col-100">
      <h5 class="card-header text-dark">Order Summary</h5>
    </div>
  </div>

  <div class="row">
    <div class="col col-50">
      {{ plan_name }}
    </div>
    <div class="col col-50 text-right">
      ${{ plan_amount }}/month
    </div>
  </div>

  <div class="row">
    <div class="col col-50">
      Install Date
    </div>
    <div class="col col-50 text-right">
      {{ formatDate install_date 'MMM Do, YYYY' }}
    </div>
  </div>

  {{#if has_trial}}
  <div class="row">
    <div class="col col-50 capitalize">
      Promotional Period
    </div>
    <div class="col col-50 text-right">
      {{ formattedTrial.duration }} {{ formattedTrial.unit }}
    </div>
  </div>
  {{/if}}

  {{#if referral_code_used}}
    <div class="row">
      <div class="col col-50 capitalize">
        Referral Credit
      </div>
      <div class="col col-50 text-right">
        {{ formatted_referral.duration }} {{ formatted_referral.unit }}
      </div>
    </div>
  {{/if}}

  <div class="row">
    <div class="col col-50">
      Billing Start Date
      <span class="install-date-disclaimer">(calculated from install date)</span>
    </div>
    <div class="col col-50 text-right">
      {{ billingStart }}<br/>
    </div>
  </div>

  <div class="row row--border-top pt1 text-bold">
    <div class="col col-50">
      Due at Install
    </div>
    <div class="col col-50 text-right">
      ${{ dueAtInstall }}
    </div>
  </div>

</div>

<div class="row js-promoContainer card-layout promo-code-container card-layout--order-summary text-dark">
  <form class="promo-form">
    <input type="text" {{#if disabled}} disabled {{/if}} placeholder="Have a promo code?" value="{{trial_code}}" id="promo-input" class="{{#if hasError}}has-error{{/if}} js-promoCode ignore input--promo-code" name="promo_code" />
    <button type="submit" {{#if disabled}} disabled {{/if}} class="js-applyPromo btn btn--apply-promo {{btnClass}}">
      {{btnText}}
    </button>
  </form>

  <div class="js-promoDetails promo-results">
    {{#if errorMessage }}
      <p class="promo-error mt1">{{ errorMessage }}</p>
    {{/if}}

    {{#if promo_message}}
      <p class="promo-success mt1">
        {{promo_message}}
      </p>
    {{else if promo_period_days }}
      <p class="promo-success mt1">
        Promo code applied. You just got {{ formatTrial promo_period_days }} free!
      </p>
    {{/if}}
  </div>
</div>
